// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centered{position:absolute;left:50%;top:50%;margin-right:-50%;transform:translate(-50%, -50%)}", ""]);
// Exports
module.exports = exports;
